(() => {
  const params = new URLSearchParams(window.location.search);
  if (params.get('tt_confirm') !== '1') return;

  const initialize = () => {
    const product = document.querySelector('product-info');
    if (!product || product.dataset.ttConfirmationReady === 'true') return;
    product.dataset.ttConfirmationReady = 'true';

    const quantity = product.querySelector('input[name="quantity"]');
    const requestedQuantity = Math.max(1, Number(params.get('tt_quantity')) || 1);
    if (quantity) {
      quantity.value = requestedQuantity;
      quantity.dispatchEvent(new Event('change', { bubbles: true }));
    }

    const buttons = product.querySelector('.product-form__buttons');
    if (!buttons) return;

    const notice = document.createElement('div');
    notice.className = 'tt-confirmation-notice';
    notice.setAttribute('role', 'status');
    notice.innerHTML = `
      <strong>Dernière vérification</strong>
      <span>Ta couleur, ta taille et ta quantité sont préparées. Clique maintenant sur le bouton officiel « Ajouter au panier ».</span>
    `;
    buttons.prepend(notice);

    const style = document.createElement('style');
    style.textContent = `
      .tt-confirmation-notice {
        margin: 0 0 14px;
        padding: 14px 16px;
        border: 1px solid #dc2d3d;
        border-radius: 8px;
        background: #fff5f5;
        color: #111a43;
        line-height: 1.4;
      }
      .tt-confirmation-notice strong,
      .tt-confirmation-notice span { display: block; }
      .tt-confirmation-notice strong {
        margin-bottom: 4px;
        color: #dc2d3d;
        text-transform: uppercase;
        letter-spacing: .06em;
      }
    `;
    document.head.appendChild(style);
    buttons.scrollIntoView({ behavior: 'smooth', block: 'center' });
  };

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', initialize, { once: true })
    : initialize();
})();
